// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as SplatRouteImport } from './routes/$'
import { Route as AboutRouteImport } from './routes/about'
import { Route as AccessibilityRouteImport } from './routes/accessibility'
import { Route as AccountRouteImport } from './routes/account'
import { Route as AmbassadorsRouteImport } from './routes/ambassadors'
import { Route as AuthRouteImport } from './routes/auth'
import { Route as BodyCareSetRouteImport } from './routes/body-care-set'
import { Route as CartRouteImport } from './routes/cart'
import { Route as ContactRouteImport } from './routes/contact'
import { Route as CookiesRouteImport } from './routes/cookies'
import { Route as CopyrightRouteImport } from './routes/copyright'
import { Route as FaqRouteImport } from './routes/faq'
import { Route as ForgotPasswordRouteImport } from './routes/forgot-password'
import { Route as GiftsRouteImport } from './routes/gifts'
import { Route as JournalRouteImport } from './routes/journal'
import { Route as PrivacyRouteImport } from './routes/privacy'
import { Route as ResetPasswordRouteImport } from './routes/reset-password'
import { Route as ReturnsRouteImport } from './routes/returns'
import { Route as ShippingRouteImport } from './routes/shipping'
import { Route as ShopRouteImport } from './routes/shop'
import { Route as TermsRouteImport } from './routes/terms'
import { Route as ThankYouRouteImport } from './routes/thank-you'
import { Route as TrackOrderRouteImport } from './routes/track-order'
import { Route as UaeRouteImport } from './routes/uae'
import { Route as UnsubscribeRouteImport } from './routes/unsubscribe'
import { Route as WholesaleRouteImport } from './routes/wholesale'
import { Route as AccountIndexRouteImport } from './routes/account.index'
import { Route as AccountAmbassadorRouteImport } from './routes/account.ambassador'
import { Route as AccountAnalyticsRouteImport } from './routes/account.analytics'
import { Route as AccountApplicationsRouteImport } from './routes/account.applications'
import { Route as AccountCouponsRouteImport } from './routes/account.coupons'
import { Route as AccountInstallAppRouteImport } from './routes/account.install-app'
import { Route as AccountLedgerRouteImport } from './routes/account.ledger'
import { Route as AccountMediaRouteImport } from './routes/account.media'
import { Route as AccountOrdersRouteImport } from './routes/account.orders'
import { Route as AccountProfileRouteImport } from './routes/account.profile'
import { Route as AccountRecipientsRouteImport } from './routes/account.recipients'
import { Route as AccountWishlistRouteImport } from './routes/account.wishlist'
import { Route as AdminIndexRouteImport } from './routes/admin.index'
import { Route as AdminAboutUsRouteImport } from './routes/admin.about-us'
import { Route as AdminAccountMenuRouteImport } from './routes/admin.account-menu'
import { Route as AdminAdsConversionsRouteImport } from './routes/admin.ads-conversions'
import { Route as AdminAgentRouteImport } from './routes/admin.agent'
import { Route as AdminAgentChatsRouteImport } from './routes/admin.agent-chats'
import { Route as AdminAgentFeedbackRouteImport } from './routes/admin.agent-feedback'
import { Route as AdminAgentInsightsRouteImport } from './routes/admin.agent-insights'
import { Route as AdminAgentRulesRouteImport } from './routes/admin.agent-rules'
import { Route as AdminAiCreditsRouteImport } from './routes/admin.ai-credits'
import { Route as AdminAlertsRouteImport } from './routes/admin.alerts'
import { Route as AdminAmbassadorClicksDebugRouteImport } from './routes/admin.ambassador-clicks-debug'
import { Route as AdminAmbassadorCodeAuditRouteImport } from './routes/admin.ambassador-code-audit'
import { Route as AdminAmbassadorContactRouteImport } from './routes/admin.ambassador-contact'
import { Route as AdminAmbassadorGiftsRouteImport } from './routes/admin.ambassador-gifts'
import { Route as AdminAmbassadorMediaRouteImport } from './routes/admin.ambassador-media'
import { Route as AdminAmbassadorMonitorRouteImport } from './routes/admin.ambassador-monitor'
import { Route as AdminAmbassadorRemindersRouteImport } from './routes/admin.ambassador-reminders'
import { Route as AdminAmbassadorSalesRouteImport } from './routes/admin.ambassador-sales'
import { Route as AdminAmbassadorTreeRouteImport } from './routes/admin.ambassador-tree'
import { Route as AdminAmbassadorsRouteImport } from './routes/admin.ambassadors'
import { Route as AdminAnalyticsRouteImport } from './routes/admin.analytics'
import { Route as AdminApplicationsRouteImport } from './routes/admin.applications'
import { Route as AdminAuthFunnelRouteImport } from './routes/admin.auth-funnel'
import { Route as AdminBannersRouteImport } from './routes/admin.banners'
import { Route as AdminBusinessSettingsRouteImport } from './routes/admin.business-settings'
import { Route as AdminCampaignAnalyticsRouteImport } from './routes/admin.campaign-analytics'
import { Route as AdminCampaignSendsRouteImport } from './routes/admin.campaign-sends'
import { Route as AdminCampaignsRouteImport } from './routes/admin.campaigns'
import { Route as AdminCartRemindersRouteImport } from './routes/admin.cart-reminders'
import { Route as AdminCelebritiesRouteImport } from './routes/admin.celebrities'
import { Route as AdminCollectionOverlaysRouteImport } from './routes/admin.collection-overlays'
import { Route as AdminComplianceComposerRouteImport } from './routes/admin.compliance-composer'
import { Route as AdminControlCenterRouteImport } from './routes/admin.control-center'
import { Route as AdminCrmRouteImport } from './routes/admin.crm'
import { Route as AdminDemographicsRouteImport } from './routes/admin.demographics'
import { Route as AdminDiscoveryBlockRouteImport } from './routes/admin.discovery-block'
import { Route as AdminDriversRouteImport } from './routes/admin.drivers'
import { Route as AdminDriversMonitorRouteImport } from './routes/admin.drivers-monitor'
import { Route as AdminEditorPicksRouteImport } from './routes/admin.editor-picks'
import { Route as AdminEmailSuppressionsRouteImport } from './routes/admin.email-suppressions'
import { Route as AdminExitIntentRouteImport } from './routes/admin.exit-intent'
import { Route as AdminFeaturedProductsRouteImport } from './routes/admin.featured-products'
import { Route as AdminFunnelReportRouteImport } from './routes/admin.funnel-report'
import { Route as AdminFunnelsRouteImport } from './routes/admin.funnels'
import { Route as AdminGa4ConnectionsRouteImport } from './routes/admin.ga4-connections'
import { Route as AdminGalleriesRouteImport } from './routes/admin.galleries'
import { Route as AdminGiftAccountingRouteImport } from './routes/admin.gift-accounting'
import { Route as AdminGiftFlowRouteImport } from './routes/admin.gift-flow'
import { Route as AdminGiftPickupRouteImport } from './routes/admin.gift-pickup'
import { Route as AdminGiftsRouteImport } from './routes/admin.gifts'
import { Route as AdminGiftsHubRouteImport } from './routes/admin.gifts-hub'
import { Route as AdminGuideRouteImport } from './routes/admin.guide'
import { Route as AdminHighlightsRouteImport } from './routes/admin.highlights'
import { Route as AdminHomeAboutRouteImport } from './routes/admin.home-about'
import { Route as AdminHomeBlockOpacityRouteImport } from './routes/admin.home-block-opacity'
import { Route as AdminHomeBlocksRouteImport } from './routes/admin.home-blocks'
import { Route as AdminHomeBlocksHubRouteImport } from './routes/admin.home-blocks-hub'
import { Route as AdminHomeBlocksSimpleRouteImport } from './routes/admin.home-blocks-simple'
import { Route as AdminHomeDesktopRouteImport } from './routes/admin.home-desktop'
import { Route as AdminHomeEditorialNoteRouteImport } from './routes/admin.home-editorial-note'
import { Route as AdminHomeInfoBlocksRouteImport } from './routes/admin.home-info-blocks'
import { Route as AdminHomeProductVideoRouteImport } from './routes/admin.home-product-video'
import { Route as AdminHomeQuoteVideoRouteImport } from './routes/admin.home-quote-video'
import { Route as AdminHomeSixGridRouteImport } from './routes/admin.home-six-grid'
import { Route as AdminHomeSoftBannerRouteImport } from './routes/admin.home-soft-banner'
import { Route as AdminHomeSpotlightRouteImport } from './routes/admin.home-spotlight'
import { Route as AdminHomeStoryBannerRouteImport } from './routes/admin.home-story-banner'
import { Route as AdminHomeTextsRouteImport } from './routes/admin.home-texts'
import { Route as AdminIntroSplashRouteImport } from './routes/admin.intro-splash'
import { Route as AdminLaunchChecklistRouteImport } from './routes/admin.launch-checklist'
import { Route as AdminLinksRouteImport } from './routes/admin.links'
import { Route as AdminLinksCleanupRouteImport } from './routes/admin.links-cleanup'
import { Route as AdminLooxStatusRouteImport } from './routes/admin.loox-status'
import { Route as AdminMarketingHealthRouteImport } from './routes/admin.marketing-health'
import { Route as AdminMediaSharesRouteImport } from './routes/admin.media-shares'
import { Route as AdminMessagesRouteImport } from './routes/admin.messages'
import { Route as AdminMetaPerformanceRouteImport } from './routes/admin.meta-performance'
import { Route as AdminMilestonesSummaryRouteImport } from './routes/admin.milestones-summary'
import { Route as AdminNewProductRouteImport } from './routes/admin.new-product'
import { Route as AdminNewsletterRouteImport } from './routes/admin.newsletter'
import { Route as AdminNotificationsLogRouteImport } from './routes/admin.notifications-log'
import { Route as AdminOccasionRemindersRouteImport } from './routes/admin.occasion-reminders'
import { Route as AdminOrderQueueRouteImport } from './routes/admin.order-queue'
import { Route as AdminOrderWebhooksRouteImport } from './routes/admin.order-webhooks'
import { Route as AdminOrdersRouteImport } from './routes/admin.orders'
import { Route as AdminPageBackgroundsRouteImport } from './routes/admin.page-backgrounds'
import { Route as AdminPagesRouteImport } from './routes/admin.pages'
import { Route as AdminPaymentMethodDebugRouteImport } from './routes/admin.payment-method-debug'
import { Route as AdminPayoutsRouteImport } from './routes/admin.payouts'
import { Route as AdminPerformanceRouteImport } from './routes/admin.performance'
import { Route as AdminPhoneLookupRouteImport } from './routes/admin.phone-lookup'
import { Route as AdminPhoneMessagesRouteImport } from './routes/admin.phone-messages'
import { Route as AdminPickupBranchesRouteImport } from './routes/admin.pickup-branches'
import { Route as AdminPopupImagesRouteImport } from './routes/admin.popup-images'
import { Route as AdminPreviewAsAmbassadorRouteImport } from './routes/admin.preview-as-ambassador'
import { Route as AdminPreviewAuditRouteImport } from './routes/admin.preview-audit'
import { Route as AdminProductDiscoveryKitRouteImport } from './routes/admin.product-discovery-kit'
import { Route as AdminProductFeedRouteImport } from './routes/admin.product-feed'
import { Route as AdminProductLifestyleRouteImport } from './routes/admin.product-lifestyle'
import { Route as AdminProductScentNotesRouteImport } from './routes/admin.product-scent-notes'
import { Route as AdminProductStoryBlocksRouteImport } from './routes/admin.product-story-blocks'
import { Route as AdminProductTranslationsRouteImport } from './routes/admin.product-translations'
import { Route as AdminProgramHubRouteImport } from './routes/admin.program-hub'
import { Route as AdminProjectStatusRouteImport } from './routes/admin.project-status'
import { Route as AdminPwaInstallsRouteImport } from './routes/admin.pwa-installs'
import { Route as AdminRedirectCheckRouteImport } from './routes/admin.redirect-check'
import { Route as AdminReminderCampaignsRouteImport } from './routes/admin.reminder-campaigns'
import { Route as AdminRepresentativesRouteImport } from './routes/admin.representatives'
import { Route as AdminReviewsRouteImport } from './routes/admin.reviews'
import { Route as AdminSalesProfitRouteImport } from './routes/admin.sales-profit'
import { Route as AdminScentSprayRouteImport } from './routes/admin.scent-spray'
import { Route as AdminScentTaxonomyRouteImport } from './routes/admin.scent-taxonomy'
import { Route as AdminSearchInsightsRouteImport } from './routes/admin.search-insights'
import { Route as AdminSeasonalCampaignsRouteImport } from './routes/admin.seasonal-campaigns'
import { Route as AdminSeoAuditRouteImport } from './routes/admin.seo-audit'
import { Route as AdminShopCollectionsRouteImport } from './routes/admin.shop-collections'
import { Route as AdminShopifyAuditRouteImport } from './routes/admin.shopify-audit'
import { Route as AdminSiteHealthRouteImport } from './routes/admin.site-health'
import { Route as AdminStorageCleanupRouteImport } from './routes/admin.storage-cleanup'
import { Route as AdminTeamRouteImport } from './routes/admin.team'
import { Route as AdminTermsGuideRouteImport } from './routes/admin.terms-guide'
import { Route as AdminThankyouVideosRouteImport } from './routes/admin.thankyou-videos'
import { Route as AdminTogglesRouteImport } from './routes/admin.toggles'
import { Route as AdminTrackingConsistencyRouteImport } from './routes/admin.tracking-consistency'
import { Route as AdminTrackingHealthRouteImport } from './routes/admin.tracking-health'
import { Route as AdminUppromoteImportRouteImport } from './routes/admin.uppromote-import'
import { Route as AdminUsersRouteImport } from './routes/admin.users'
import { Route as AdminVisitorDialogsRouteImport } from './routes/admin.visitor-dialogs'
import { Route as AdminVisitorDialogsAnalyticsRouteImport } from './routes/admin.visitor-dialogs-analytics'
import { Route as AdminWebPushRouteImport } from './routes/admin.web-push'
import { Route as AdminWebhooksStatusRouteImport } from './routes/admin.webhooks-status'
import { Route as AdminWhatsappModeRouteImport } from './routes/admin.whatsapp-mode'
import { Route as AdminWhatsappOptInsRouteImport } from './routes/admin.whatsapp-opt-ins'
import { Route as AdminWhatsappTemplatesRouteImport } from './routes/admin.whatsapp-templates'
import { Route as AdminWhatsappUsageRouteImport } from './routes/admin.whatsapp-usage'
import { Route as AdminWholesaleRouteImport } from './routes/admin.wholesale'
import { Route as AdminWishlistVsCartRouteImport } from './routes/admin.wishlist-vs-cart'
import { Route as AdminWooImportRouteImport } from './routes/admin.woo-import'
import { Route as AmbassadorsIndexRouteImport } from './routes/ambassadors.index'
import { Route as AmbassadorsJoinTermsRouteImport } from './routes/ambassadors.join-terms'
import { Route as AmbassadorsJoinedRouteImport } from './routes/ambassadors.joined'
import { Route as AmbassadorsTermsRouteImport } from './routes/ambassadors.terms'
import { Route as CollectionHandleRouteImport } from './routes/collection.$handle'
import { Route as DriverIndexRouteImport } from './routes/driver.index'
import { Route as JournalIndexRouteImport } from './routes/journal.index'
import { Route as JournalSlugRouteImport } from './routes/journal.$slug'
import { Route as LSlugRouteImport } from './routes/l.$slug'
import { Route as NewProductIndexRouteImport } from './routes/new-product.index'
import { Route as NewProductSlugRouteImport } from './routes/new-product.$slug'
import { Route as OrderTokenRouteImport } from './routes/order.$token'
import { Route as PSlugRouteImport } from './routes/p.$slug'
import { Route as ProductHandleRouteImport } from './routes/product.$handle'
import { Route as RepresentativeOrdersRouteImport } from './routes/representative.orders'
import { Route as DotlovableOauthConsentRouteImport } from './routes/[.]lovable.oauth.consent'
import { Route as AccountAnalyticsSelectPropertyRouteImport } from './routes/account.analytics.select-property'
import { Route as AccountGiftsIndexRouteImport } from './routes/account.gifts.index'
import { Route as AdminBirthdayGiftsIndexRouteImport } from './routes/admin.birthday-gifts.index'
import { Route as AdminBirthdayGiftsLogRouteImport } from './routes/admin.birthday-gifts.log'
import { Route as AdminDriversIndexRouteImport } from './routes/admin.drivers.index'
import { Route as AdminDriversIdRouteImport } from './routes/admin.drivers.$id'
import { Route as AdminPagesIndexRouteImport } from './routes/admin.pages.index'
import { Route as AdminPagesIdRouteImport } from './routes/admin.pages.$id'
import { Route as AdminProductsCopyRouteImport } from './routes/admin.products.copy'
import { Route as AmbassadorsTierKeyRouteImport } from './routes/ambassadors.tier.$key'
import { Route as DriverOrdersIdRouteImport } from './routes/driver.orders.$id'
import { Route as AccountGiftsBirthdayOfferIdRouteImport } from './routes/account.gifts.birthday.$offerId'

const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const SplatRoute = SplatRouteImport.update({
            id: '/$',path: '/$',getParentRoute: () => rootRouteImport
          })
const AboutRoute = AboutRouteImport.update({
            id: '/about',path: '/about',getParentRoute: () => rootRouteImport
          })
const AccessibilityRoute = AccessibilityRouteImport.update({
            id: '/accessibility',path: '/accessibility',getParentRoute: () => rootRouteImport
          })
const AccountRoute = AccountRouteImport.update({
            id: '/account',path: '/account',getParentRoute: () => rootRouteImport
          })
const AmbassadorsRoute = AmbassadorsRouteImport.update({
            id: '/ambassadors',path: '/ambassadors',getParentRoute: () => rootRouteImport
          })
const AuthRoute = AuthRouteImport.update({
            id: '/auth',path: '/auth',getParentRoute: () => rootRouteImport
          })
const BodyCareSetRoute = BodyCareSetRouteImport.update({
            id: '/body-care-set',path: '/body-care-set',getParentRoute: () => rootRouteImport
          })
const CartRoute = CartRouteImport.update({
            id: '/cart',path: '/cart',getParentRoute: () => rootRouteImport
          })
const ContactRoute = ContactRouteImport.update({
            id: '/contact',path: '/contact',getParentRoute: () => rootRouteImport
          })
const CookiesRoute = CookiesRouteImport.update({
            id: '/cookies',path: '/cookies',getParentRoute: () => rootRouteImport
          })
const CopyrightRoute = CopyrightRouteImport.update({
            id: '/copyright',path: '/copyright',getParentRoute: () => rootRouteImport
          })
const FaqRoute = FaqRouteImport.update({
            id: '/faq',path: '/faq',getParentRoute: () => rootRouteImport
          })
const ForgotPasswordRoute = ForgotPasswordRouteImport.update({
            id: '/forgot-password',path: '/forgot-password',getParentRoute: () => rootRouteImport
          })
const GiftsRoute = GiftsRouteImport.update({
            id: '/gifts',path: '/gifts',getParentRoute: () => rootRouteImport
          })
const JournalRoute = JournalRouteImport.update({
            id: '/journal',path: '/journal',getParentRoute: () => rootRouteImport
          })
const PrivacyRoute = PrivacyRouteImport.update({
            id: '/privacy',path: '/privacy',getParentRoute: () => rootRouteImport
          })
const ResetPasswordRoute = ResetPasswordRouteImport.update({
            id: '/reset-password',path: '/reset-password',getParentRoute: () => rootRouteImport
          })
const ReturnsRoute = ReturnsRouteImport.update({
            id: '/returns',path: '/returns',getParentRoute: () => rootRouteImport
          })
const ShippingRoute = ShippingRouteImport.update({
            id: '/shipping',path: '/shipping',getParentRoute: () => rootRouteImport
          })
const ShopRoute = ShopRouteImport.update({
            id: '/shop',path: '/shop',getParentRoute: () => rootRouteImport
          })
const TermsRoute = TermsRouteImport.update({
            id: '/terms',path: '/terms',getParentRoute: () => rootRouteImport
          })
const ThankYouRoute = ThankYouRouteImport.update({
            id: '/thank-you',path: '/thank-you',getParentRoute: () => rootRouteImport
          })
const TrackOrderRoute = TrackOrderRouteImport.update({
            id: '/track-order',path: '/track-order',getParentRoute: () => rootRouteImport
          })
const UaeRoute = UaeRouteImport.update({
            id: '/uae',path: '/uae',getParentRoute: () => rootRouteImport
          })
const UnsubscribeRoute = UnsubscribeRouteImport.update({
            id: '/unsubscribe',path: '/unsubscribe',getParentRoute: () => rootRouteImport
          })
const WholesaleRoute = WholesaleRouteImport.update({
            id: '/wholesale',path: '/wholesale',getParentRoute: () => rootRouteImport
          })
const AccountIndexRoute = AccountIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AccountRoute
          })
const AccountAmbassadorRoute = AccountAmbassadorRouteImport.update({
            id: '/ambassador',path: '/ambassador',getParentRoute: () => AccountRoute
          })
const AccountAnalyticsRoute = AccountAnalyticsRouteImport.update({
            id: '/analytics',path: '/analytics',getParentRoute: () => AccountRoute
          })
const AccountApplicationsRoute = AccountApplicationsRouteImport.update({
            id: '/applications',path: '/applications',getParentRoute: () => AccountRoute
          })
const AccountCouponsRoute = AccountCouponsRouteImport.update({
            id: '/coupons',path: '/coupons',getParentRoute: () => AccountRoute
          })
const AccountInstallAppRoute = AccountInstallAppRouteImport.update({
            id: '/install-app',path: '/install-app',getParentRoute: () => AccountRoute
          })
const AccountLedgerRoute = AccountLedgerRouteImport.update({
            id: '/ledger',path: '/ledger',getParentRoute: () => AccountRoute
          })
const AccountMediaRoute = AccountMediaRouteImport.update({
            id: '/media',path: '/media',getParentRoute: () => AccountRoute
          })
const AccountOrdersRoute = AccountOrdersRouteImport.update({
            id: '/orders',path: '/orders',getParentRoute: () => AccountRoute
          })
const AccountProfileRoute = AccountProfileRouteImport.update({
            id: '/profile',path: '/profile',getParentRoute: () => AccountRoute
          })
const AccountRecipientsRoute = AccountRecipientsRouteImport.update({
            id: '/recipients',path: '/recipients',getParentRoute: () => AccountRoute
          })
const AccountWishlistRoute = AccountWishlistRouteImport.update({
            id: '/wishlist',path: '/wishlist',getParentRoute: () => AccountRoute
          })
const AdminIndexRoute = AdminIndexRouteImport.update({
            id: '/admin/',path: '/admin/',getParentRoute: () => rootRouteImport
          })
const AdminAboutUsRoute = AdminAboutUsRouteImport.update({
            id: '/admin/about-us',path: '/admin/about-us',getParentRoute: () => rootRouteImport
          })
const AdminAccountMenuRoute = AdminAccountMenuRouteImport.update({
            id: '/admin/account-menu',path: '/admin/account-menu',getParentRoute: () => rootRouteImport
          })
const AdminAdsConversionsRoute = AdminAdsConversionsRouteImport.update({
            id: '/admin/ads-conversions',path: '/admin/ads-conversions',getParentRoute: () => rootRouteImport
          })
const AdminAgentRoute = AdminAgentRouteImport.update({
            id: '/admin/agent',path: '/admin/agent',getParentRoute: () => rootRouteImport
          })
const AdminAgentChatsRoute = AdminAgentChatsRouteImport.update({
            id: '/admin/agent-chats',path: '/admin/agent-chats',getParentRoute: () => rootRouteImport
          })
const AdminAgentFeedbackRoute = AdminAgentFeedbackRouteImport.update({
            id: '/admin/agent-feedback',path: '/admin/agent-feedback',getParentRoute: () => rootRouteImport
          })
const AdminAgentInsightsRoute = AdminAgentInsightsRouteImport.update({
            id: '/admin/agent-insights',path: '/admin/agent-insights',getParentRoute: () => rootRouteImport
          })
const AdminAgentRulesRoute = AdminAgentRulesRouteImport.update({
            id: '/admin/agent-rules',path: '/admin/agent-rules',getParentRoute: () => rootRouteImport
          })
const AdminAiCreditsRoute = AdminAiCreditsRouteImport.update({
            id: '/admin/ai-credits',path: '/admin/ai-credits',getParentRoute: () => rootRouteImport
          })
const AdminAlertsRoute = AdminAlertsRouteImport.update({
            id: '/admin/alerts',path: '/admin/alerts',getParentRoute: () => rootRouteImport
          })
const AdminAmbassadorClicksDebugRoute = AdminAmbassadorClicksDebugRouteImport.update({
            id: '/admin/ambassador-clicks-debug',path: '/admin/ambassador-clicks-debug',getParentRoute: () => rootRouteImport
          })
const AdminAmbassadorCodeAuditRoute = AdminAmbassadorCodeAuditRouteImport.update({
            id: '/admin/ambassador-code-audit',path: '/admin/ambassador-code-audit',getParentRoute: () => rootRouteImport
          })
const AdminAmbassadorContactRoute = AdminAmbassadorContactRouteImport.update({
            id: '/admin/ambassador-contact',path: '/admin/ambassador-contact',getParentRoute: () => rootRouteImport
          })
const AdminAmbassadorGiftsRoute = AdminAmbassadorGiftsRouteImport.update({
            id: '/admin/ambassador-gifts',path: '/admin/ambassador-gifts',getParentRoute: () => rootRouteImport
          })
const AdminAmbassadorMediaRoute = AdminAmbassadorMediaRouteImport.update({
            id: '/admin/ambassador-media',path: '/admin/ambassador-media',getParentRoute: () => rootRouteImport
          })
const AdminAmbassadorMonitorRoute = AdminAmbassadorMonitorRouteImport.update({
            id: '/admin/ambassador-monitor',path: '/admin/ambassador-monitor',getParentRoute: () => rootRouteImport
          })
const AdminAmbassadorRemindersRoute = AdminAmbassadorRemindersRouteImport.update({
            id: '/admin/ambassador-reminders',path: '/admin/ambassador-reminders',getParentRoute: () => rootRouteImport
          })
const AdminAmbassadorSalesRoute = AdminAmbassadorSalesRouteImport.update({
            id: '/admin/ambassador-sales',path: '/admin/ambassador-sales',getParentRoute: () => rootRouteImport
          })
const AdminAmbassadorTreeRoute = AdminAmbassadorTreeRouteImport.update({
            id: '/admin/ambassador-tree',path: '/admin/ambassador-tree',getParentRoute: () => rootRouteImport
          })
const AdminAmbassadorsRoute = AdminAmbassadorsRouteImport.update({
            id: '/admin/ambassadors',path: '/admin/ambassadors',getParentRoute: () => rootRouteImport
          })
const AdminAnalyticsRoute = AdminAnalyticsRouteImport.update({
            id: '/admin/analytics',path: '/admin/analytics',getParentRoute: () => rootRouteImport
          })
const AdminApplicationsRoute = AdminApplicationsRouteImport.update({
            id: '/admin/applications',path: '/admin/applications',getParentRoute: () => rootRouteImport
          })
const AdminAuthFunnelRoute = AdminAuthFunnelRouteImport.update({
            id: '/admin/auth-funnel',path: '/admin/auth-funnel',getParentRoute: () => rootRouteImport
          })
const AdminBannersRoute = AdminBannersRouteImport.update({
            id: '/admin/banners',path: '/admin/banners',getParentRoute: () => rootRouteImport
          })
const AdminBusinessSettingsRoute = AdminBusinessSettingsRouteImport.update({
            id: '/admin/business-settings',path: '/admin/business-settings',getParentRoute: () => rootRouteImport
          })
const AdminCampaignAnalyticsRoute = AdminCampaignAnalyticsRouteImport.update({
            id: '/admin/campaign-analytics',path: '/admin/campaign-analytics',getParentRoute: () => rootRouteImport
          })
const AdminCampaignSendsRoute = AdminCampaignSendsRouteImport.update({
            id: '/admin/campaign-sends',path: '/admin/campaign-sends',getParentRoute: () => rootRouteImport
          })
const AdminCampaignsRoute = AdminCampaignsRouteImport.update({
            id: '/admin/campaigns',path: '/admin/campaigns',getParentRoute: () => rootRouteImport
          })
const AdminCartRemindersRoute = AdminCartRemindersRouteImport.update({
            id: '/admin/cart-reminders',path: '/admin/cart-reminders',getParentRoute: () => rootRouteImport
          })
const AdminCelebritiesRoute = AdminCelebritiesRouteImport.update({
            id: '/admin/celebrities',path: '/admin/celebrities',getParentRoute: () => rootRouteImport
          })
const AdminCollectionOverlaysRoute = AdminCollectionOverlaysRouteImport.update({
            id: '/admin/collection-overlays',path: '/admin/collection-overlays',getParentRoute: () => rootRouteImport
          })
const AdminComplianceComposerRoute = AdminComplianceComposerRouteImport.update({
            id: '/admin/compliance-composer',path: '/admin/compliance-composer',getParentRoute: () => rootRouteImport
          })
const AdminControlCenterRoute = AdminControlCenterRouteImport.update({
            id: '/admin/control-center',path: '/admin/control-center',getParentRoute: () => rootRouteImport
          })
const AdminCrmRoute = AdminCrmRouteImport.update({
            id: '/admin/crm',path: '/admin/crm',getParentRoute: () => rootRouteImport
          })
const AdminDemographicsRoute = AdminDemographicsRouteImport.update({
            id: '/admin/demographics',path: '/admin/demographics',getParentRoute: () => rootRouteImport
          })
const AdminDiscoveryBlockRoute = AdminDiscoveryBlockRouteImport.update({
            id: '/admin/discovery-block',path: '/admin/discovery-block',getParentRoute: () => rootRouteImport
          })
const AdminDriversRoute = AdminDriversRouteImport.update({
            id: '/admin/drivers',path: '/admin/drivers',getParentRoute: () => rootRouteImport
          })
const AdminDriversMonitorRoute = AdminDriversMonitorRouteImport.update({
            id: '/admin/drivers-monitor',path: '/admin/drivers-monitor',getParentRoute: () => rootRouteImport
          })
const AdminEditorPicksRoute = AdminEditorPicksRouteImport.update({
            id: '/admin/editor-picks',path: '/admin/editor-picks',getParentRoute: () => rootRouteImport
          })
const AdminEmailSuppressionsRoute = AdminEmailSuppressionsRouteImport.update({
            id: '/admin/email-suppressions',path: '/admin/email-suppressions',getParentRoute: () => rootRouteImport
          })
const AdminExitIntentRoute = AdminExitIntentRouteImport.update({
            id: '/admin/exit-intent',path: '/admin/exit-intent',getParentRoute: () => rootRouteImport
          })
const AdminFeaturedProductsRoute = AdminFeaturedProductsRouteImport.update({
            id: '/admin/featured-products',path: '/admin/featured-products',getParentRoute: () => rootRouteImport
          })
const AdminFunnelReportRoute = AdminFunnelReportRouteImport.update({
            id: '/admin/funnel-report',path: '/admin/funnel-report',getParentRoute: () => rootRouteImport
          })
const AdminFunnelsRoute = AdminFunnelsRouteImport.update({
            id: '/admin/funnels',path: '/admin/funnels',getParentRoute: () => rootRouteImport
          })
const AdminGa4ConnectionsRoute = AdminGa4ConnectionsRouteImport.update({
            id: '/admin/ga4-connections',path: '/admin/ga4-connections',getParentRoute: () => rootRouteImport
          })
const AdminGalleriesRoute = AdminGalleriesRouteImport.update({
            id: '/admin/galleries',path: '/admin/galleries',getParentRoute: () => rootRouteImport
          })
const AdminGiftAccountingRoute = AdminGiftAccountingRouteImport.update({
            id: '/admin/gift-accounting',path: '/admin/gift-accounting',getParentRoute: () => rootRouteImport
          })
const AdminGiftFlowRoute = AdminGiftFlowRouteImport.update({
            id: '/admin/gift-flow',path: '/admin/gift-flow',getParentRoute: () => rootRouteImport
          })
const AdminGiftPickupRoute = AdminGiftPickupRouteImport.update({
            id: '/admin/gift-pickup',path: '/admin/gift-pickup',getParentRoute: () => rootRouteImport
          })
const AdminGiftsRoute = AdminGiftsRouteImport.update({
            id: '/admin/gifts',path: '/admin/gifts',getParentRoute: () => rootRouteImport
          })
const AdminGiftsHubRoute = AdminGiftsHubRouteImport.update({
            id: '/admin/gifts-hub',path: '/admin/gifts-hub',getParentRoute: () => rootRouteImport
          })
const AdminGuideRoute = AdminGuideRouteImport.update({
            id: '/admin/guide',path: '/admin/guide',getParentRoute: () => rootRouteImport
          })
const AdminHighlightsRoute = AdminHighlightsRouteImport.update({
            id: '/admin/highlights',path: '/admin/highlights',getParentRoute: () => rootRouteImport
          })
const AdminHomeAboutRoute = AdminHomeAboutRouteImport.update({
            id: '/admin/home-about',path: '/admin/home-about',getParentRoute: () => rootRouteImport
          })
const AdminHomeBlockOpacityRoute = AdminHomeBlockOpacityRouteImport.update({
            id: '/admin/home-block-opacity',path: '/admin/home-block-opacity',getParentRoute: () => rootRouteImport
          })
const AdminHomeBlocksRoute = AdminHomeBlocksRouteImport.update({
            id: '/admin/home-blocks',path: '/admin/home-blocks',getParentRoute: () => rootRouteImport
          })
const AdminHomeBlocksHubRoute = AdminHomeBlocksHubRouteImport.update({
            id: '/admin/home-blocks-hub',path: '/admin/home-blocks-hub',getParentRoute: () => rootRouteImport
          })
const AdminHomeBlocksSimpleRoute = AdminHomeBlocksSimpleRouteImport.update({
            id: '/admin/home-blocks-simple',path: '/admin/home-blocks-simple',getParentRoute: () => rootRouteImport
          })
const AdminHomeDesktopRoute = AdminHomeDesktopRouteImport.update({
            id: '/admin/home-desktop',path: '/admin/home-desktop',getParentRoute: () => rootRouteImport
          })
const AdminHomeEditorialNoteRoute = AdminHomeEditorialNoteRouteImport.update({
            id: '/admin/home-editorial-note',path: '/admin/home-editorial-note',getParentRoute: () => rootRouteImport
          })
const AdminHomeInfoBlocksRoute = AdminHomeInfoBlocksRouteImport.update({
            id: '/admin/home-info-blocks',path: '/admin/home-info-blocks',getParentRoute: () => rootRouteImport
          })
const AdminHomeProductVideoRoute = AdminHomeProductVideoRouteImport.update({
            id: '/admin/home-product-video',path: '/admin/home-product-video',getParentRoute: () => rootRouteImport
          })
const AdminHomeQuoteVideoRoute = AdminHomeQuoteVideoRouteImport.update({
            id: '/admin/home-quote-video',path: '/admin/home-quote-video',getParentRoute: () => rootRouteImport
          })
const AdminHomeSixGridRoute = AdminHomeSixGridRouteImport.update({
            id: '/admin/home-six-grid',path: '/admin/home-six-grid',getParentRoute: () => rootRouteImport
          })
const AdminHomeSoftBannerRoute = AdminHomeSoftBannerRouteImport.update({
            id: '/admin/home-soft-banner',path: '/admin/home-soft-banner',getParentRoute: () => rootRouteImport
          })
const AdminHomeSpotlightRoute = AdminHomeSpotlightRouteImport.update({
            id: '/admin/home-spotlight',path: '/admin/home-spotlight',getParentRoute: () => rootRouteImport
          })
const AdminHomeStoryBannerRoute = AdminHomeStoryBannerRouteImport.update({
            id: '/admin/home-story-banner',path: '/admin/home-story-banner',getParentRoute: () => rootRouteImport
          })
const AdminHomeTextsRoute = AdminHomeTextsRouteImport.update({
            id: '/admin/home-texts',path: '/admin/home-texts',getParentRoute: () => rootRouteImport
          })
const AdminIntroSplashRoute = AdminIntroSplashRouteImport.update({
            id: '/admin/intro-splash',path: '/admin/intro-splash',getParentRoute: () => rootRouteImport
          })
const AdminLaunchChecklistRoute = AdminLaunchChecklistRouteImport.update({
            id: '/admin/launch-checklist',path: '/admin/launch-checklist',getParentRoute: () => rootRouteImport
          })
const AdminLinksRoute = AdminLinksRouteImport.update({
            id: '/admin/links',path: '/admin/links',getParentRoute: () => rootRouteImport
          })
const AdminLinksCleanupRoute = AdminLinksCleanupRouteImport.update({
            id: '/admin/links-cleanup',path: '/admin/links-cleanup',getParentRoute: () => rootRouteImport
          })
const AdminLooxStatusRoute = AdminLooxStatusRouteImport.update({
            id: '/admin/loox-status',path: '/admin/loox-status',getParentRoute: () => rootRouteImport
          })
const AdminMarketingHealthRoute = AdminMarketingHealthRouteImport.update({
            id: '/admin/marketing-health',path: '/admin/marketing-health',getParentRoute: () => rootRouteImport
          })
const AdminMediaSharesRoute = AdminMediaSharesRouteImport.update({
            id: '/admin/media-shares',path: '/admin/media-shares',getParentRoute: () => rootRouteImport
          })
const AdminMessagesRoute = AdminMessagesRouteImport.update({
            id: '/admin/messages',path: '/admin/messages',getParentRoute: () => rootRouteImport
          })
const AdminMetaPerformanceRoute = AdminMetaPerformanceRouteImport.update({
            id: '/admin/meta-performance',path: '/admin/meta-performance',getParentRoute: () => rootRouteImport
          })
const AdminMilestonesSummaryRoute = AdminMilestonesSummaryRouteImport.update({
            id: '/admin/milestones-summary',path: '/admin/milestones-summary',getParentRoute: () => rootRouteImport
          })
const AdminNewProductRoute = AdminNewProductRouteImport.update({
            id: '/admin/new-product',path: '/admin/new-product',getParentRoute: () => rootRouteImport
          })
const AdminNewsletterRoute = AdminNewsletterRouteImport.update({
            id: '/admin/newsletter',path: '/admin/newsletter',getParentRoute: () => rootRouteImport
          })
const AdminNotificationsLogRoute = AdminNotificationsLogRouteImport.update({
            id: '/admin/notifications-log',path: '/admin/notifications-log',getParentRoute: () => rootRouteImport
          })
const AdminOccasionRemindersRoute = AdminOccasionRemindersRouteImport.update({
            id: '/admin/occasion-reminders',path: '/admin/occasion-reminders',getParentRoute: () => rootRouteImport
          })
const AdminOrderQueueRoute = AdminOrderQueueRouteImport.update({
            id: '/admin/order-queue',path: '/admin/order-queue',getParentRoute: () => rootRouteImport
          })
const AdminOrderWebhooksRoute = AdminOrderWebhooksRouteImport.update({
            id: '/admin/order-webhooks',path: '/admin/order-webhooks',getParentRoute: () => rootRouteImport
          })
const AdminOrdersRoute = AdminOrdersRouteImport.update({
            id: '/admin/orders',path: '/admin/orders',getParentRoute: () => rootRouteImport
          })
const AdminPageBackgroundsRoute = AdminPageBackgroundsRouteImport.update({
            id: '/admin/page-backgrounds',path: '/admin/page-backgrounds',getParentRoute: () => rootRouteImport
          })
const AdminPagesRoute = AdminPagesRouteImport.update({
            id: '/admin/pages',path: '/admin/pages',getParentRoute: () => rootRouteImport
          })
const AdminPaymentMethodDebugRoute = AdminPaymentMethodDebugRouteImport.update({
            id: '/admin/payment-method-debug',path: '/admin/payment-method-debug',getParentRoute: () => rootRouteImport
          })
const AdminPayoutsRoute = AdminPayoutsRouteImport.update({
            id: '/admin/payouts',path: '/admin/payouts',getParentRoute: () => rootRouteImport
          })
const AdminPerformanceRoute = AdminPerformanceRouteImport.update({
            id: '/admin/performance',path: '/admin/performance',getParentRoute: () => rootRouteImport
          })
const AdminPhoneLookupRoute = AdminPhoneLookupRouteImport.update({
            id: '/admin/phone-lookup',path: '/admin/phone-lookup',getParentRoute: () => rootRouteImport
          })
const AdminPhoneMessagesRoute = AdminPhoneMessagesRouteImport.update({
            id: '/admin/phone-messages',path: '/admin/phone-messages',getParentRoute: () => rootRouteImport
          })
const AdminPickupBranchesRoute = AdminPickupBranchesRouteImport.update({
            id: '/admin/pickup-branches',path: '/admin/pickup-branches',getParentRoute: () => rootRouteImport
          })
const AdminPopupImagesRoute = AdminPopupImagesRouteImport.update({
            id: '/admin/popup-images',path: '/admin/popup-images',getParentRoute: () => rootRouteImport
          })
const AdminPreviewAsAmbassadorRoute = AdminPreviewAsAmbassadorRouteImport.update({
            id: '/admin/preview-as-ambassador',path: '/admin/preview-as-ambassador',getParentRoute: () => rootRouteImport
          })
const AdminPreviewAuditRoute = AdminPreviewAuditRouteImport.update({
            id: '/admin/preview-audit',path: '/admin/preview-audit',getParentRoute: () => rootRouteImport
          })
const AdminProductDiscoveryKitRoute = AdminProductDiscoveryKitRouteImport.update({
            id: '/admin/product-discovery-kit',path: '/admin/product-discovery-kit',getParentRoute: () => rootRouteImport
          })
const AdminProductFeedRoute = AdminProductFeedRouteImport.update({
            id: '/admin/product-feed',path: '/admin/product-feed',getParentRoute: () => rootRouteImport
          })
const AdminProductLifestyleRoute = AdminProductLifestyleRouteImport.update({
            id: '/admin/product-lifestyle',path: '/admin/product-lifestyle',getParentRoute: () => rootRouteImport
          })
const AdminProductScentNotesRoute = AdminProductScentNotesRouteImport.update({
            id: '/admin/product-scent-notes',path: '/admin/product-scent-notes',getParentRoute: () => rootRouteImport
          })
const AdminProductStoryBlocksRoute = AdminProductStoryBlocksRouteImport.update({
            id: '/admin/product-story-blocks',path: '/admin/product-story-blocks',getParentRoute: () => rootRouteImport
          })
const AdminProductTranslationsRoute = AdminProductTranslationsRouteImport.update({
            id: '/admin/product-translations',path: '/admin/product-translations',getParentRoute: () => rootRouteImport
          })
const AdminProgramHubRoute = AdminProgramHubRouteImport.update({
            id: '/admin/program-hub',path: '/admin/program-hub',getParentRoute: () => rootRouteImport
          })
const AdminProjectStatusRoute = AdminProjectStatusRouteImport.update({
            id: '/admin/project-status',path: '/admin/project-status',getParentRoute: () => rootRouteImport
          })
const AdminPwaInstallsRoute = AdminPwaInstallsRouteImport.update({
            id: '/admin/pwa-installs',path: '/admin/pwa-installs',getParentRoute: () => rootRouteImport
          })
const AdminRedirectCheckRoute = AdminRedirectCheckRouteImport.update({
            id: '/admin/redirect-check',path: '/admin/redirect-check',getParentRoute: () => rootRouteImport
          })
const AdminReminderCampaignsRoute = AdminReminderCampaignsRouteImport.update({
            id: '/admin/reminder-campaigns',path: '/admin/reminder-campaigns',getParentRoute: () => rootRouteImport
          })
const AdminRepresentativesRoute = AdminRepresentativesRouteImport.update({
            id: '/admin/representatives',path: '/admin/representatives',getParentRoute: () => rootRouteImport
          })
const AdminReviewsRoute = AdminReviewsRouteImport.update({
            id: '/admin/reviews',path: '/admin/reviews',getParentRoute: () => rootRouteImport
          })
const AdminSalesProfitRoute = AdminSalesProfitRouteImport.update({
            id: '/admin/sales-profit',path: '/admin/sales-profit',getParentRoute: () => rootRouteImport
          })
const AdminScentSprayRoute = AdminScentSprayRouteImport.update({
            id: '/admin/scent-spray',path: '/admin/scent-spray',getParentRoute: () => rootRouteImport
          })
const AdminScentTaxonomyRoute = AdminScentTaxonomyRouteImport.update({
            id: '/admin/scent-taxonomy',path: '/admin/scent-taxonomy',getParentRoute: () => rootRouteImport
          })
const AdminSearchInsightsRoute = AdminSearchInsightsRouteImport.update({
            id: '/admin/search-insights',path: '/admin/search-insights',getParentRoute: () => rootRouteImport
          })
const AdminSeasonalCampaignsRoute = AdminSeasonalCampaignsRouteImport.update({
            id: '/admin/seasonal-campaigns',path: '/admin/seasonal-campaigns',getParentRoute: () => rootRouteImport
          })
const AdminSeoAuditRoute = AdminSeoAuditRouteImport.update({
            id: '/admin/seo-audit',path: '/admin/seo-audit',getParentRoute: () => rootRouteImport
          })
const AdminShopCollectionsRoute = AdminShopCollectionsRouteImport.update({
            id: '/admin/shop-collections',path: '/admin/shop-collections',getParentRoute: () => rootRouteImport
          })
const AdminShopifyAuditRoute = AdminShopifyAuditRouteImport.update({
            id: '/admin/shopify-audit',path: '/admin/shopify-audit',getParentRoute: () => rootRouteImport
          })
const AdminSiteHealthRoute = AdminSiteHealthRouteImport.update({
            id: '/admin/site-health',path: '/admin/site-health',getParentRoute: () => rootRouteImport
          })
const AdminStorageCleanupRoute = AdminStorageCleanupRouteImport.update({
            id: '/admin/storage-cleanup',path: '/admin/storage-cleanup',getParentRoute: () => rootRouteImport
          })
const AdminTeamRoute = AdminTeamRouteImport.update({
            id: '/admin/team',path: '/admin/team',getParentRoute: () => rootRouteImport
          })
const AdminTermsGuideRoute = AdminTermsGuideRouteImport.update({
            id: '/admin/terms-guide',path: '/admin/terms-guide',getParentRoute: () => rootRouteImport
          })
const AdminThankyouVideosRoute = AdminThankyouVideosRouteImport.update({
            id: '/admin/thankyou-videos',path: '/admin/thankyou-videos',getParentRoute: () => rootRouteImport
          })
const AdminTogglesRoute = AdminTogglesRouteImport.update({
            id: '/admin/toggles',path: '/admin/toggles',getParentRoute: () => rootRouteImport
          })
const AdminTrackingConsistencyRoute = AdminTrackingConsistencyRouteImport.update({
            id: '/admin/tracking-consistency',path: '/admin/tracking-consistency',getParentRoute: () => rootRouteImport
          })
const AdminTrackingHealthRoute = AdminTrackingHealthRouteImport.update({
            id: '/admin/tracking-health',path: '/admin/tracking-health',getParentRoute: () => rootRouteImport
          })
const AdminUppromoteImportRoute = AdminUppromoteImportRouteImport.update({
            id: '/admin/uppromote-import',path: '/admin/uppromote-import',getParentRoute: () => rootRouteImport
          })
const AdminUsersRoute = AdminUsersRouteImport.update({
            id: '/admin/users',path: '/admin/users',getParentRoute: () => rootRouteImport
          })
const AdminVisitorDialogsRoute = AdminVisitorDialogsRouteImport.update({
            id: '/admin/visitor-dialogs',path: '/admin/visitor-dialogs',getParentRoute: () => rootRouteImport
          })
const AdminVisitorDialogsAnalyticsRoute = AdminVisitorDialogsAnalyticsRouteImport.update({
            id: '/admin/visitor-dialogs-analytics',path: '/admin/visitor-dialogs-analytics',getParentRoute: () => rootRouteImport
          })
const AdminWebPushRoute = AdminWebPushRouteImport.update({
            id: '/admin/web-push',path: '/admin/web-push',getParentRoute: () => rootRouteImport
          })
const AdminWebhooksStatusRoute = AdminWebhooksStatusRouteImport.update({
            id: '/admin/webhooks-status',path: '/admin/webhooks-status',getParentRoute: () => rootRouteImport
          })
const AdminWhatsappModeRoute = AdminWhatsappModeRouteImport.update({
            id: '/admin/whatsapp-mode',path: '/admin/whatsapp-mode',getParentRoute: () => rootRouteImport
          })
const AdminWhatsappOptInsRoute = AdminWhatsappOptInsRouteImport.update({
            id: '/admin/whatsapp-opt-ins',path: '/admin/whatsapp-opt-ins',getParentRoute: () => rootRouteImport
          })
const AdminWhatsappTemplatesRoute = AdminWhatsappTemplatesRouteImport.update({
            id: '/admin/whatsapp-templates',path: '/admin/whatsapp-templates',getParentRoute: () => rootRouteImport
          })
const AdminWhatsappUsageRoute = AdminWhatsappUsageRouteImport.update({
            id: '/admin/whatsapp-usage',path: '/admin/whatsapp-usage',getParentRoute: () => rootRouteImport
          })
const AdminWholesaleRoute = AdminWholesaleRouteImport.update({
            id: '/admin/wholesale',path: '/admin/wholesale',getParentRoute: () => rootRouteImport
          })
const AdminWishlistVsCartRoute = AdminWishlistVsCartRouteImport.update({
            id: '/admin/wishlist-vs-cart',path: '/admin/wishlist-vs-cart',getParentRoute: () => rootRouteImport
          })
const AdminWooImportRoute = AdminWooImportRouteImport.update({
            id: '/admin/woo-import',path: '/admin/woo-import',getParentRoute: () => rootRouteImport
          })
const AmbassadorsIndexRoute = AmbassadorsIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AmbassadorsRoute
          })
const AmbassadorsJoinTermsRoute = AmbassadorsJoinTermsRouteImport.update({
            id: '/join-terms',path: '/join-terms',getParentRoute: () => AmbassadorsRoute
          })
const AmbassadorsJoinedRoute = AmbassadorsJoinedRouteImport.update({
            id: '/joined',path: '/joined',getParentRoute: () => AmbassadorsRoute
          })
const AmbassadorsTermsRoute = AmbassadorsTermsRouteImport.update({
            id: '/terms',path: '/terms',getParentRoute: () => AmbassadorsRoute
          })
const CollectionHandleRoute = CollectionHandleRouteImport.update({
            id: '/collection/$handle',path: '/collection/$handle',getParentRoute: () => rootRouteImport
          })
const DriverIndexRoute = DriverIndexRouteImport.update({
            id: '/driver/',path: '/driver/',getParentRoute: () => rootRouteImport
          })
const JournalIndexRoute = JournalIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => JournalRoute
          })
const JournalSlugRoute = JournalSlugRouteImport.update({
            id: '/$slug',path: '/$slug',getParentRoute: () => JournalRoute
          })
const LSlugRoute = LSlugRouteImport.update({
            id: '/l/$slug',path: '/l/$slug',getParentRoute: () => rootRouteImport
          })
const NewProductIndexRoute = NewProductIndexRouteImport.update({
            id: '/new-product/',path: '/new-product/',getParentRoute: () => rootRouteImport
          })
const NewProductSlugRoute = NewProductSlugRouteImport.update({
            id: '/new-product/$slug',path: '/new-product/$slug',getParentRoute: () => rootRouteImport
          })
const OrderTokenRoute = OrderTokenRouteImport.update({
            id: '/order/$token',path: '/order/$token',getParentRoute: () => rootRouteImport
          })
const PSlugRoute = PSlugRouteImport.update({
            id: '/p/$slug',path: '/p/$slug',getParentRoute: () => rootRouteImport
          })
const ProductHandleRoute = ProductHandleRouteImport.update({
            id: '/product/$handle',path: '/product/$handle',getParentRoute: () => rootRouteImport
          })
const RepresentativeOrdersRoute = RepresentativeOrdersRouteImport.update({
            id: '/representative/orders',path: '/representative/orders',getParentRoute: () => rootRouteImport
          })
const DotlovableOauthConsentRoute = DotlovableOauthConsentRouteImport.update({
            id: '/.lovable/oauth/consent',path: '/.lovable/oauth/consent',getParentRoute: () => rootRouteImport
          })
const AccountAnalyticsSelectPropertyRoute = AccountAnalyticsSelectPropertyRouteImport.update({
            id: '/select-property',path: '/select-property',getParentRoute: () => AccountAnalyticsRoute
          })
const AccountGiftsIndexRoute = AccountGiftsIndexRouteImport.update({
            id: '/gifts/',path: '/gifts/',getParentRoute: () => AccountRoute
          })
const AdminBirthdayGiftsIndexRoute = AdminBirthdayGiftsIndexRouteImport.update({
            id: '/admin/birthday-gifts/',path: '/admin/birthday-gifts/',getParentRoute: () => rootRouteImport
          })
const AdminBirthdayGiftsLogRoute = AdminBirthdayGiftsLogRouteImport.update({
            id: '/admin/birthday-gifts/log',path: '/admin/birthday-gifts/log',getParentRoute: () => rootRouteImport
          })
const AdminDriversIndexRoute = AdminDriversIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AdminDriversRoute
          })
const AdminDriversIdRoute = AdminDriversIdRouteImport.update({
            id: '/$id',path: '/$id',getParentRoute: () => AdminDriversRoute
          })
const AdminPagesIndexRoute = AdminPagesIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AdminPagesRoute
          })
const AdminPagesIdRoute = AdminPagesIdRouteImport.update({
            id: '/$id',path: '/$id',getParentRoute: () => AdminPagesRoute
          })
const AdminProductsCopyRoute = AdminProductsCopyRouteImport.update({
            id: '/admin/products/copy',path: '/admin/products/copy',getParentRoute: () => rootRouteImport
          })
const AmbassadorsTierKeyRoute = AmbassadorsTierKeyRouteImport.update({
            id: '/tier/$key',path: '/tier/$key',getParentRoute: () => AmbassadorsRoute
          })
const DriverOrdersIdRoute = DriverOrdersIdRouteImport.update({
            id: '/driver/orders/$id',path: '/driver/orders/$id',getParentRoute: () => rootRouteImport
          })
const AccountGiftsBirthdayOfferIdRoute = AccountGiftsBirthdayOfferIdRouteImport.update({
            id: '/gifts/birthday/$offerId',path: '/gifts/birthday/$offerId',getParentRoute: () => AccountRoute
          })





const AccountAnalyticsRouteChildren = {
  AccountAnalyticsSelectPropertyRoute: AccountAnalyticsSelectPropertyRoute
}

const AccountAnalyticsRouteWithChildren = AccountAnalyticsRoute._addFileChildren(AccountAnalyticsRouteChildren)



const AccountRouteChildren = {
  AccountAmbassadorRoute: AccountAmbassadorRoute,AccountAnalyticsRoute: AccountAnalyticsRouteWithChildren,AccountApplicationsRoute: AccountApplicationsRoute,AccountCouponsRoute: AccountCouponsRoute,AccountInstallAppRoute: AccountInstallAppRoute,AccountLedgerRoute: AccountLedgerRoute,AccountMediaRoute: AccountMediaRoute,AccountOrdersRoute: AccountOrdersRoute,AccountProfileRoute: AccountProfileRoute,AccountRecipientsRoute: AccountRecipientsRoute,AccountWishlistRoute: AccountWishlistRoute,AccountIndexRoute: AccountIndexRoute,AccountGiftsIndexRoute: AccountGiftsIndexRoute,AccountGiftsBirthdayOfferIdRoute: AccountGiftsBirthdayOfferIdRoute
}

const AccountRouteWithChildren = AccountRoute._addFileChildren(AccountRouteChildren)




const AmbassadorsRouteChildren = {
  AmbassadorsJoinTermsRoute: AmbassadorsJoinTermsRoute,AmbassadorsJoinedRoute: AmbassadorsJoinedRoute,AmbassadorsTermsRoute: AmbassadorsTermsRoute,AmbassadorsIndexRoute: AmbassadorsIndexRoute,AmbassadorsTierKeyRoute: AmbassadorsTierKeyRoute
}

const AmbassadorsRouteWithChildren = AmbassadorsRoute._addFileChildren(AmbassadorsRouteChildren)




const JournalRouteChildren = {
  JournalSlugRoute: JournalSlugRoute,JournalIndexRoute: JournalIndexRoute
}

const JournalRouteWithChildren = JournalRoute._addFileChildren(JournalRouteChildren)




const AdminDriversRouteChildren = {
  AdminDriversIdRoute: AdminDriversIdRoute,AdminDriversIndexRoute: AdminDriversIndexRoute
}

const AdminDriversRouteWithChildren = AdminDriversRoute._addFileChildren(AdminDriversRouteChildren)




const AdminPagesRouteChildren = {
  AdminPagesIdRoute: AdminPagesIdRoute,AdminPagesIndexRoute: AdminPagesIndexRoute
}

const AdminPagesRouteWithChildren = AdminPagesRoute._addFileChildren(AdminPagesRouteChildren)

const rootRouteChildren = {
  IndexRoute: IndexRoute,SplatRoute: SplatRoute,AboutRoute: AboutRoute,AccessibilityRoute: AccessibilityRoute,AccountRoute: AccountRouteWithChildren,AmbassadorsRoute: AmbassadorsRouteWithChildren,AuthRoute: AuthRoute,BodyCareSetRoute: BodyCareSetRoute,CartRoute: CartRoute,ContactRoute: ContactRoute,CookiesRoute: CookiesRoute,CopyrightRoute: CopyrightRoute,FaqRoute: FaqRoute,ForgotPasswordRoute: ForgotPasswordRoute,GiftsRoute: GiftsRoute,JournalRoute: JournalRouteWithChildren,PrivacyRoute: PrivacyRoute,ResetPasswordRoute: ResetPasswordRoute,ReturnsRoute: ReturnsRoute,ShippingRoute: ShippingRoute,ShopRoute: ShopRoute,TermsRoute: TermsRoute,ThankYouRoute: ThankYouRoute,TrackOrderRoute: TrackOrderRoute,UaeRoute: UaeRoute,UnsubscribeRoute: UnsubscribeRoute,WholesaleRoute: WholesaleRoute,AdminAboutUsRoute: AdminAboutUsRoute,AdminAccountMenuRoute: AdminAccountMenuRoute,AdminAdsConversionsRoute: AdminAdsConversionsRoute,AdminAgentRoute: AdminAgentRoute,AdminAgentChatsRoute: AdminAgentChatsRoute,AdminAgentFeedbackRoute: AdminAgentFeedbackRoute,AdminAgentInsightsRoute: AdminAgentInsightsRoute,AdminAgentRulesRoute: AdminAgentRulesRoute,AdminAiCreditsRoute: AdminAiCreditsRoute,AdminAlertsRoute: AdminAlertsRoute,AdminAmbassadorClicksDebugRoute: AdminAmbassadorClicksDebugRoute,AdminAmbassadorCodeAuditRoute: AdminAmbassadorCodeAuditRoute,AdminAmbassadorContactRoute: AdminAmbassadorContactRoute,AdminAmbassadorGiftsRoute: AdminAmbassadorGiftsRoute,AdminAmbassadorMediaRoute: AdminAmbassadorMediaRoute,AdminAmbassadorMonitorRoute: AdminAmbassadorMonitorRoute,AdminAmbassadorRemindersRoute: AdminAmbassadorRemindersRoute,AdminAmbassadorSalesRoute: AdminAmbassadorSalesRoute,AdminAmbassadorTreeRoute: AdminAmbassadorTreeRoute,AdminAmbassadorsRoute: AdminAmbassadorsRoute,AdminAnalyticsRoute: AdminAnalyticsRoute,AdminApplicationsRoute: AdminApplicationsRoute,AdminAuthFunnelRoute: AdminAuthFunnelRoute,AdminBannersRoute: AdminBannersRoute,AdminBusinessSettingsRoute: AdminBusinessSettingsRoute,AdminCampaignAnalyticsRoute: AdminCampaignAnalyticsRoute,AdminCampaignSendsRoute: AdminCampaignSendsRoute,AdminCampaignsRoute: AdminCampaignsRoute,AdminCartRemindersRoute: AdminCartRemindersRoute,AdminCelebritiesRoute: AdminCelebritiesRoute,AdminCollectionOverlaysRoute: AdminCollectionOverlaysRoute,AdminComplianceComposerRoute: AdminComplianceComposerRoute,AdminControlCenterRoute: AdminControlCenterRoute,AdminCrmRoute: AdminCrmRoute,AdminDemographicsRoute: AdminDemographicsRoute,AdminDiscoveryBlockRoute: AdminDiscoveryBlockRoute,AdminDriversRoute: AdminDriversRouteWithChildren,AdminDriversMonitorRoute: AdminDriversMonitorRoute,AdminEditorPicksRoute: AdminEditorPicksRoute,AdminEmailSuppressionsRoute: AdminEmailSuppressionsRoute,AdminExitIntentRoute: AdminExitIntentRoute,AdminFeaturedProductsRoute: AdminFeaturedProductsRoute,AdminFunnelReportRoute: AdminFunnelReportRoute,AdminFunnelsRoute: AdminFunnelsRoute,AdminGa4ConnectionsRoute: AdminGa4ConnectionsRoute,AdminGalleriesRoute: AdminGalleriesRoute,AdminGiftAccountingRoute: AdminGiftAccountingRoute,AdminGiftFlowRoute: AdminGiftFlowRoute,AdminGiftPickupRoute: AdminGiftPickupRoute,AdminGiftsRoute: AdminGiftsRoute,AdminGiftsHubRoute: AdminGiftsHubRoute,AdminGuideRoute: AdminGuideRoute,AdminHighlightsRoute: AdminHighlightsRoute,AdminHomeAboutRoute: AdminHomeAboutRoute,AdminHomeBlockOpacityRoute: AdminHomeBlockOpacityRoute,AdminHomeBlocksRoute: AdminHomeBlocksRoute,AdminHomeBlocksHubRoute: AdminHomeBlocksHubRoute,AdminHomeBlocksSimpleRoute: AdminHomeBlocksSimpleRoute,AdminHomeDesktopRoute: AdminHomeDesktopRoute,AdminHomeEditorialNoteRoute: AdminHomeEditorialNoteRoute,AdminHomeInfoBlocksRoute: AdminHomeInfoBlocksRoute,AdminHomeProductVideoRoute: AdminHomeProductVideoRoute,AdminHomeQuoteVideoRoute: AdminHomeQuoteVideoRoute,AdminHomeSixGridRoute: AdminHomeSixGridRoute,AdminHomeSoftBannerRoute: AdminHomeSoftBannerRoute,AdminHomeSpotlightRoute: AdminHomeSpotlightRoute,AdminHomeStoryBannerRoute: AdminHomeStoryBannerRoute,AdminHomeTextsRoute: AdminHomeTextsRoute,AdminIntroSplashRoute: AdminIntroSplashRoute,AdminLaunchChecklistRoute: AdminLaunchChecklistRoute,AdminLinksRoute: AdminLinksRoute,AdminLinksCleanupRoute: AdminLinksCleanupRoute,AdminLooxStatusRoute: AdminLooxStatusRoute,AdminMarketingHealthRoute: AdminMarketingHealthRoute,AdminMediaSharesRoute: AdminMediaSharesRoute,AdminMessagesRoute: AdminMessagesRoute,AdminMetaPerformanceRoute: AdminMetaPerformanceRoute,AdminMilestonesSummaryRoute: AdminMilestonesSummaryRoute,AdminNewProductRoute: AdminNewProductRoute,AdminNewsletterRoute: AdminNewsletterRoute,AdminNotificationsLogRoute: AdminNotificationsLogRoute,AdminOccasionRemindersRoute: AdminOccasionRemindersRoute,AdminOrderQueueRoute: AdminOrderQueueRoute,AdminOrderWebhooksRoute: AdminOrderWebhooksRoute,AdminOrdersRoute: AdminOrdersRoute,AdminPageBackgroundsRoute: AdminPageBackgroundsRoute,AdminPagesRoute: AdminPagesRouteWithChildren,AdminPaymentMethodDebugRoute: AdminPaymentMethodDebugRoute,AdminPayoutsRoute: AdminPayoutsRoute,AdminPerformanceRoute: AdminPerformanceRoute,AdminPhoneLookupRoute: AdminPhoneLookupRoute,AdminPhoneMessagesRoute: AdminPhoneMessagesRoute,AdminPickupBranchesRoute: AdminPickupBranchesRoute,AdminPopupImagesRoute: AdminPopupImagesRoute,AdminPreviewAsAmbassadorRoute: AdminPreviewAsAmbassadorRoute,AdminPreviewAuditRoute: AdminPreviewAuditRoute,AdminProductDiscoveryKitRoute: AdminProductDiscoveryKitRoute,AdminProductFeedRoute: AdminProductFeedRoute,AdminProductLifestyleRoute: AdminProductLifestyleRoute,AdminProductScentNotesRoute: AdminProductScentNotesRoute,AdminProductStoryBlocksRoute: AdminProductStoryBlocksRoute,AdminProductTranslationsRoute: AdminProductTranslationsRoute,AdminProgramHubRoute: AdminProgramHubRoute,AdminProjectStatusRoute: AdminProjectStatusRoute,AdminPwaInstallsRoute: AdminPwaInstallsRoute,AdminRedirectCheckRoute: AdminRedirectCheckRoute,AdminReminderCampaignsRoute: AdminReminderCampaignsRoute,AdminRepresentativesRoute: AdminRepresentativesRoute,AdminReviewsRoute: AdminReviewsRoute,AdminSalesProfitRoute: AdminSalesProfitRoute,AdminScentSprayRoute: AdminScentSprayRoute,AdminScentTaxonomyRoute: AdminScentTaxonomyRoute,AdminSearchInsightsRoute: AdminSearchInsightsRoute,AdminSeasonalCampaignsRoute: AdminSeasonalCampaignsRoute,AdminSeoAuditRoute: AdminSeoAuditRoute,AdminShopCollectionsRoute: AdminShopCollectionsRoute,AdminShopifyAuditRoute: AdminShopifyAuditRoute,AdminSiteHealthRoute: AdminSiteHealthRoute,AdminStorageCleanupRoute: AdminStorageCleanupRoute,AdminTeamRoute: AdminTeamRoute,AdminTermsGuideRoute: AdminTermsGuideRoute,AdminThankyouVideosRoute: AdminThankyouVideosRoute,AdminTogglesRoute: AdminTogglesRoute,AdminTrackingConsistencyRoute: AdminTrackingConsistencyRoute,AdminTrackingHealthRoute: AdminTrackingHealthRoute,AdminUppromoteImportRoute: AdminUppromoteImportRoute,AdminUsersRoute: AdminUsersRoute,AdminVisitorDialogsRoute: AdminVisitorDialogsRoute,AdminVisitorDialogsAnalyticsRoute: AdminVisitorDialogsAnalyticsRoute,AdminWebPushRoute: AdminWebPushRoute,AdminWebhooksStatusRoute: AdminWebhooksStatusRoute,AdminWhatsappModeRoute: AdminWhatsappModeRoute,AdminWhatsappOptInsRoute: AdminWhatsappOptInsRoute,AdminWhatsappTemplatesRoute: AdminWhatsappTemplatesRoute,AdminWhatsappUsageRoute: AdminWhatsappUsageRoute,AdminWholesaleRoute: AdminWholesaleRoute,AdminWishlistVsCartRoute: AdminWishlistVsCartRoute,AdminWooImportRoute: AdminWooImportRoute,CollectionHandleRoute: CollectionHandleRoute,LSlugRoute: LSlugRoute,NewProductSlugRoute: NewProductSlugRoute,OrderTokenRoute: OrderTokenRoute,PSlugRoute: PSlugRoute,ProductHandleRoute: ProductHandleRoute,RepresentativeOrdersRoute: RepresentativeOrdersRoute,AdminIndexRoute: AdminIndexRoute,DriverIndexRoute: DriverIndexRoute,NewProductIndexRoute: NewProductIndexRoute,DotlovableOauthConsentRoute: DotlovableOauthConsentRoute,AdminBirthdayGiftsLogRoute: AdminBirthdayGiftsLogRoute,AdminProductsCopyRoute: AdminProductsCopyRoute,DriverOrdersIdRoute: DriverOrdersIdRoute,AdminBirthdayGiftsIndexRoute: AdminBirthdayGiftsIndexRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)